export default __webpack_public_path__ + "static/media/boite9.d8ff510b.jpg";